<template>
  <main></main>
</template>

<script>
import EventBus from '@/globals/eventBus'

export default {
  mounted () {
    EventBus.$emit('set-telemedicine-offline')

    this.$http('/logout', this.$store.getters.getAuthHeader).catch(
      (err) => {
        console.log(err)
      }
    ).finally(
      () => {
        this.fn_HIDE_PROGRESS()
        this.$store.dispatch('clearAuth')
        this.$store.dispatch('unsetCurrentOffice')
        this.$router.replace({name: 'Index'})
        localStorage.removeItem('sessionOfficeId')
      }
    )
  }
}
</script>
